module.exports = __webpack_public_path__ + "img/inter-ali.d8e3e28f.c2b7ce7b.png";